import classNames from 'classnames';
import { ISnowStatus, OpenFlag, SurfaceType } from 'api/resort/types';
import { DistanceUnit } from 'components/blocks/Unit';
import { SnowType } from 'components/blocks/SnowType';

import { useOTSTranslation } from 'i18n/useOTSTranslation';
import cellStyles from './styles.module.scss';

interface IBaseDepthCellProps {
  openFlag?: OpenFlag
  snow?: ISnowStatus
  surfaceType?: SurfaceType
  noValue: string
}

const BaseDepthCell = ({
  openFlag, snow, surfaceType, noValue,
}: IBaseDepthCellProps) => {
  const { t } = useOTSTranslation('common');
  const hasSnowValue = (!!snow?.base || !!snow?.summit || !!snow?.middle) && (openFlag !== OpenFlag.NoReportAvailable);

  // If base and summit depth not available, default to middle depth as some resorts only report middle
  const snowValues = !snow?.base && !snow?.summit ? [snow?.middle] : [snow?.base, snow?.summit];

  return (
    <span className={classNames('h4', cellStyles.h4)}>
      {hasSnowValue
        ? (
          <DistanceUnit
            type="cmOrInchShort"
            separator="-"
            values={snowValues}
            noValue={t('common.dash') as I18nKeyGenerated['common']}
            removeEqual
          />
        )
        : noValue}
      {(openFlag === OpenFlag.Open || openFlag === OpenFlag.WeekendsOnly) && hasSnowValue
        ? (
          <div className={cellStyles.small}>
            <SnowType type={surfaceType} />
          </div>
        )
        : (<div className={classNames(cellStyles.small, cellStyles.hiddenCell)}>-</div>)}
    </span>
  );
};

export default BaseDepthCell;
